export default __webpack_public_path__ + "static/media/napping.d5933351.png";